const yesNoDelegatingPortfolio = {
    yes: 'Oui',
    no: 'Non',
};

export default yesNoDelegatingPortfolio;
